import React from 'react';

function Features() {
  const features = [
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <circle cx="16" cy="16" r="14" stroke="currentColor" strokeWidth="2"/>
          <path d="M16 8 L16 16 L22 22" stroke="currentColor" strokeWidth="2"/>
        </svg>
      ),
      title: 'Cognitive Processing',
      description: 'Advanced cognitive architecture that mimics human brain processing for superior decision-making and pattern recognition.'
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <circle cx="16" cy="8" r="4" fill="currentColor"/>
          <circle cx="8" cy="20" r="4" fill="currentColor"/>
          <circle cx="24" cy="20" r="4" fill="currentColor"/>
          <line x1="16" y1="12" x2="10" y2="18" stroke="currentColor" strokeWidth="2"/>
          <line x1="16" y1="12" x2="22" y2="18" stroke="currentColor" strokeWidth="2"/>
        </svg>
      ),
      title: 'Graph Intelligence',
      description: 'Sophisticated graph-based knowledge representation enabling complex relationship mapping and contextual understanding.'
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <path d="M4 20 L12 12 L20 16 L28 8" stroke="currentColor" strokeWidth="2"/>
          <circle cx="12" cy="12" r="3" fill="currentColor"/>
          <circle cx="20" cy="16" r="3" fill="currentColor"/>
        </svg>
      ),
      title: 'Continuous Learning',
      description: 'Self-improving AI that learns from every interaction, constantly refining models and improving accuracy over time.'
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <rect x="4" y="4" width="24" height="24" rx="4" stroke="currentColor" strokeWidth="2" fill="none"/>
          <path d="M12 16 L16 20 L24 12" stroke="currentColor" strokeWidth="2"/>
        </svg>
      ),
      title: 'Enterprise Security',
      description: 'Bank-level security with end-to-end encryption, role-based access control, and comprehensive audit trails.'
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <circle cx="16" cy="16" r="12" stroke="currentColor" strokeWidth="2" fill="none"/>
          <path d="M16 8 L16 16 L22 19" stroke="currentColor" strokeWidth="2"/>
        </svg>
      ),
      title: 'Real-time Analytics',
      description: 'Instant insights and predictions with sub-second response times, enabling immediate action on critical events.'
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <path d="M8 16 L16 8 L24 16 L16 24 Z" stroke="currentColor" strokeWidth="2" fill="none"/>
          <circle cx="16" cy="16" r="4" fill="currentColor"/>
        </svg>
      ),
      title: 'Automated Decisions',
      description: 'Level 5 automation with deterministic and probabilistic reasoning for autonomous, context-aware decision-making.'
    }
  ];

  return (
    <section className="features-section" id="platform">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Powerful Features for Modern Enterprises</h2>
          <p className="section-subtitle">
            Everything you need to build intelligent, autonomous systems that learn and adapt
          </p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features;

